export const GROUND_Y = 700;
export const PLAYER_SPEED = 128;
export const GRAVITY_Y = 980;
export const JUMP_SPEED = -570;
// Center Y is chosen so the 48px block's underside is exactly y=508.
export const QUESTION_BLOCK = { x: 1200, y: 484, width: 48, height: 48 } as const;
export const COIN_JUMP_START_X = 500;
export const BLOCK_JUMP_START_X = QUESTION_BLOCK.x - 48;
